import * as React from "react";

const FilterGroup = (props: { children: React.ReactNode }) => {
  return <div className="col-12 col-xl-6 my-2 ">{props.children}</div>;
};

export default FilterGroup;
